import { render } from "./CartSummaryComponent.vue?vue&type=template&id=3ccebfc3&scoped=true"
import script from "./CartSummaryComponent.vue?vue&type=script&lang=js"
export * from "./CartSummaryComponent.vue?vue&type=script&lang=js"

import "./CartSummaryComponent.vue?vue&type=style&index=0&id=3ccebfc3&scoped=true&lang=css"

import exportComponent from "/Users/alejandrobernal/Documents/fbc/fbc-ecommerce-main-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccebfc3"]])

export default __exports__